<template>
  <div class="spl-parcel-action-bar">
    <div class="spl-parcel-action-bar__group">
      <form-label v-if="checkActionGroupPermission('parcel')" inline="true">
        Parcel
      </form-label>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE) && !singleParcel"
        class="spl-parcel-action-bar__update-parcel"
        @onClick="update_Clicked">
        Update
      </form-button>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.DELETE)"
        class="spl-parcel-action-bar__delete-parcel"
        @onClick="delete_Clicked">
        Delete
      </form-button>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.REACTIVATE)"
        class="spl-parcel-action-bar__reactivate-parcel"
        @onClick="reactivate_Clicked">
        Reactivate
      </form-button>
    </div>
    <div class="spl-parcel-action-bar__group">
      <form-label v-if="checkActionGroupPermission('event')" inline="true">
        Scan
      </form-label>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.SCAN)"
        class="spl-parcel-action-bar__add-scan"
        @onClick="scan_Clicked">
        Add
      </form-button>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.DELETE) && !singleParcel"
        class="spl-parcel-action-bar__delete-scan"
        @onClick="deactivate_Event_Clicked">
        Deactivate
      </form-button>
    </div>
    <div class="spl-parcel-action-bar__group">
      <form-label v-if="checkActionGroupPermission('problemReport')" inline="true">
        Problem Report
      </form-label>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.CREATE)"
        class="spl-parcel-action-bar__add-problem-report"
        @onClick="problem_Report_Clicked">
        Create
      </form-button>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.DELETE)"
        class="spl-parcel-action-bar__delete-problem-report"
        @onClick="deactivate_Problem_Report_Clicked">
        Deactivate
      </form-button>
    </div>
    <div class="spl-parcel-action-bar__group">
      <form-label v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)" inline="true">
        Document
      </form-label>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)"
        class="spl-parcel-action-bar__add-document"
        @onClick="upload_Document_Clicked">
        Upload
      </form-button>
      <form-button v-if="userHasPermission(constants.PERMISSION_TYPES.CMR, constants.PERMISSION_VALUES.CREATE)" @onClick="create_CMR_Clicked">
        Create
      </form-button>
    </div>
    <div class="spl-parcel-action-bar__group">
      <form-label v-if="userHasPermission(constants.PERMISSION_TYPES.DAILY_CARGO, constants.PERMISSION_VALUES.CREATE)" inline="true">
        Adhoc Drives
      </form-label>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)"
        class="spl-parcel-action-bar__add-adhoc-drive"
        @onClick="create_Adhoc_Drive_Clicked">
        Create
      </form-button>
    </div>
    <div class="spl-parcel-action-bar__group">
      <form-label v-if="userHasPermission(constants.PERMISSION_TYPES.DAILY_CARGO, constants.PERMISSION_VALUES.CREATE)" inline="true">
        Linehaul Drives
      </form-label>
      <form-button
        v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)"
        class="spl-parcel-action-bar__add-linehaul-drive"
        @onClick="create_Linehaul_Drive_Clicked">
        Create
      </form-button>
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import constants from '@/constants'
export default {
  name: 'ParcelActionBar',
  mixins: [Helpers],
  props: ['singleParcel'],
  data () {
    return { constants }
  },
  methods: {
    scan_Clicked () {
      window.bus.$emit('openScanParcelsModal')
    },
    update_Clicked () {
      this.$emit('openUpdateParcelsModal')
    },
    problem_Report_Clicked () {
      window.bus.$emit('openCreateProblemReportModal')
    },
    upload_Document_Clicked () {
      this.$emit('openUploadDocumentModal')
    },
    create_Linehaul_Drive_Clicked () {
      this.$emit('openCreateLinehaulDriveModal')
    },
    create_Adhoc_Drive_Clicked () {
      this.$emit('openCreateAdhocDriveModal')
    },
    delete_Clicked () {
      this.$emit('openDeleteParcelModal')
    },
    reactivate_Clicked () {
      this.$emit('openReactivateParcelModal')
    },
    deactivate_Problem_Report_Clicked () {
      this.$emit('deactivateProblemReport')
    },
    deactivate_Event_Clicked () {
      this.$emit('deactivateEvent')
    },
    create_CMR_Clicked () {
      this.$emit('openCreateCMRModal')
    },
    checkActionGroupPermission (permissionType) {
      switch (permissionType) {
        case 'parcel':
          return (this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE) && !this.singleParcel) || this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.DELETE)
        case 'event':
          return this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.SCAN) || this.userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.DELETE)
        case 'problemReport':
          return this.userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.CREATE)
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';
    .spl-parcel-action-bar {
        background-color: $middleYellow;
        bottom: 0;
        height: 70px;
        padding: 18px $mainPadding;
        position: fixed;
        width: 100%;
        z-index: 310;
        display: flex;

        .spl-label-inline {
          margin-left: 10px;
          margin-top: 10px;
        }

        .spl-parcel-action-bar__group {
            display: flex;
        }

        .spl-label {
            color: $darkerYellow;
        }
        .spl-button {
            background-color: $footerButtonYellow;
            color: $yellowButtonLabel;
            height: 34px;
            margin: 0 2px 0 0;
            padding: 0 10px;
        }
    }

    @include mobile() {
      .spl-parcel-action-bar {
        height: auto;
        padding: 5px;
        display: inline;
        .spl-button {
          font-size: 13px;
          margin: 5px;
        }
      }
    }
</style>
